(() => {
  // =========================
  // CONFIG (YOUR VARIANT IDS)
  // =========================
  const HOODIE = {
    S: 42793478651965,
    M: 42793478684733,
    L: 42793478717501,
    XL: 42793478750269,
    "2XL": 42793478783037,
  };

  const PANTS = {
    S: 42793474654269,
    M: 42793474687037,
    L: 42793474719805,
    XL: 42793474752573,
    "2XL": 42793474785341,
  };

  const HOODIE_IDS = new Set(Object.values(HOODIE).map(String));
  const PANTS_IDS = new Set(Object.values(PANTS).map(String));

  // Don’t nag repeatedly in the same tab/session
  const SESSION_KEYS = {
    hoodie: "cb_set_upsell_shown_hoodie",
    pants: "cb_set_upsell_shown_pants",
  };

  // =========================
  // HELPERS
  // =========================
  const getCart = async () =>
    (await fetch("/cart.js", { credentials: "same-origin" })).json();

  const hasAny = (cart, idSet) =>
    (cart.items || []).some((i) => idSet.has(String(i.variant_id)));

  const getSizeFromLine = (line) => {
    const opts = line?.options_with_values || [];
    const sizeOpt = opts.find((o) => (o?.name || "").toLowerCase() === "size");
    const raw = (sizeOpt?.value || "").toUpperCase().trim();
    if (!raw) return null;

    if (raw === "2X" || raw === "XXL") return "2XL";
    if (raw === "SMALL") return "S";
    if (raw === "MEDIUM") return "M";
    if (raw === "LARGE") return "L";
    if (raw === "EXTRA LARGE" || raw === "X-LARGE") return "XL";
    return raw;
  };

  const findTrigger = (cart) => {
    for (const line of cart.items || []) {
      const vid = String(line.variant_id);
      if (HOODIE_IDS.has(vid)) return { type: "hoodie", line };
      if (PANTS_IDS.has(vid)) return { type: "pants", line };
    }
    return null;
  };

  // =========================
  // ADD WITH SECTIONS (WORKS) + GUARANTEED SYNC
  // =========================
  const addVariantWithSections = async (variantId, qty = 1) => {
    // Even if the theme ignores section updates, the add still works.
    // We reload after add to guarantee UI sync.
    const sections = ["cart-drawer", "cart-icon-bubble"];

    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", qty);
    formData.append("sections", sections.join(","));
    formData.append("sections_url", window.location.pathname);

    const res = await fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      body: formData,
    });

    if (!res.ok) throw new Error("Add to cart failed");
    return res.json();
  };

  // =========================
  // POPUP UI
  // =========================
  const ensureModal = () => {
    if (document.getElementById("cb-set-upsell")) return;

    const style = document.createElement("style");
    style.textContent = `
      #cb-set-upsell{position:fixed;inset:0;z-index:99999;display:none}
      #cb-set-upsell .cb-backdrop{position:absolute;inset:0;background:rgba(0,0,0,.55)}
      #cb-set-upsell .cb-panel{position:relative;max-width:520px;width:92vw;margin:10vh auto 0;background:#111;border:1px solid rgba(255,255,255,.12);border-radius:18px;overflow:hidden}
      #cb-set-upsell .cb-head{padding:16px 18px;display:flex;align-items:center;justify-content:space-between;border-bottom:1px solid rgba(255,255,255,.10)}
      #cb-set-upsell .cb-title{font-size:15px;font-weight:600;color:#fff}
      #cb-set-upsell .cb-close{appearance:none;background:transparent;border:0;color:#fff;font-size:22px;line-height:1;cursor:pointer;padding:6px 10px}
      #cb-set-upsell .cb-body{padding:16px 18px;color:rgba(255,255,255,.88)}
      #cb-set-upsell .cb-name{font-size:14px;font-weight:600;color:#fff;margin:0}
      #cb-set-upsell .cb-meta{font-size:13px;opacity:.85;margin-top:4px}
      #cb-set-upsell .cb-actions{display:flex;gap:10px;margin-top:16px}
      #cb-set-upsell .cb-btn{flex:1;cursor:pointer;border-radius:14px;padding:12px 14px;font-size:14px;font-weight:600;border:1px solid rgba(255,255,255,.18);background:#fff;color:#000}
      #cb-set-upsell .cb-btn.cb-ghost{background:transparent;color:#fff}
      #cb-set-upsell .cb-note{font-size:12px;opacity:.75;margin-top:10px}
    `;
    document.head.appendChild(style);

    const wrap = document.createElement("div");
    wrap.id = "cb-set-upsell";
    wrap.innerHTML = `
      <div class="cb-backdrop"></div>
      <div class="cb-panel" role="dialog" aria-modal="true" aria-label="Complete the set">
        <div class="cb-head">
          <div class="cb-title">Complete the set</div>
          <button class="cb-close" aria-label="Close">&times;</button>
        </div>
        <div class="cb-body">
          <p class="cb-name"></p>
          <div class="cb-meta"></div>
          <div class="cb-actions">
            <button class="cb-btn" data-action="add">Add to cart</button>
            <button class="cb-btn cb-ghost" data-action="no">No thanks</button>
          </div>
          <div class="cb-note">Adding will refresh the page to update your cart.</div>
        </div>
      </div>
    `;
    document.body.appendChild(wrap);

    const close = () => (wrap.style.display = "none");
    wrap.querySelector(".cb-backdrop").addEventListener("click", close);
    wrap.querySelector(".cb-close").addEventListener("click", close);
    wrap.querySelector('[data-action="no"]').addEventListener("click", close);
  };

  const openModal = ({ name, meta, onAdd }) => {
    ensureModal();
    const wrap = document.getElementById("cb-set-upsell");

    wrap.querySelector(".cb-name").textContent = name;
    wrap.querySelector(".cb-meta").textContent = meta;

    const addBtn = wrap.querySelector('[data-action="add"]');
    addBtn.disabled = false;
    addBtn.textContent = "Add to cart";

    addBtn.onclick = async () => {
      try {
        addBtn.disabled = true;
        addBtn.textContent = "Adding…";
        await onAdd();
        wrap.style.display = "none";

        // ✅ GUARANTEED: Horizon cart drawer will now match the real cart
        setTimeout(() => window.location.reload(), 250);
      } catch {
        addBtn.disabled = false;
        addBtn.textContent = "Try again";
      }
    };

    wrap.style.display = "block";
  };

  // =========================
  // CORE LOGIC
  // =========================
  const maybeShowUpsell = async () => {
    const cart = await getCart();
    const trig = findTrigger(cart);
    if (!trig) return;

    const { type, line } = trig;

    if (sessionStorage.getItem(SESSION_KEYS[type]) === "1") return;

    const size = getSizeFromLine(line);
    if (!size) return;

    if (type === "hoodie") {
      if (hasAny(cart, PANTS_IDS)) return;

      const offerId = PANTS[size];
      if (!offerId) return;

      sessionStorage.setItem(SESSION_KEYS[type], "1");

      openModal({
        name: "Add the matching pants",
        meta: `Size: ${size}`,
        onAdd: () => addVariantWithSections(offerId, 1),
      });
      return;
    }

    if (type === "pants") {
      if (hasAny(cart, HOODIE_IDS)) return;

      const offerId = HOODIE[size];
      if (!offerId) return;

      sessionStorage.setItem(SESSION_KEYS[type], "1");

      openModal({
        name: "Add the matching hoodie",
        meta: `Size: ${size}`,
        onAdd: () => addVariantWithSections(offerId, 1),
      });
    }
  };

  // =========================
  // HOOK INTO AJAX ADD-TO-CART
  // =========================
  const hook = () => {
    const _fetch = window.fetch;
    window.fetch = async (...args) => {
      const res = await _fetch(...args);

      try {
        const url =
          args?.[0] && typeof args[0] === "string"
            ? args[0]
            : args?.[0]?.url || "";

        if (
          url.includes("/cart/add") ||
          url.includes("/cart/change") ||
          url.includes("/cart/update")
        ) {
          setTimeout(() => maybeShowUpsell().catch(() => {}), 250);
        }
      } catch {}

      return res;
    };

    setTimeout(() => maybeShowUpsell().catch(() => {}), 600);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", hook);
  } else {
    hook();
  }
})();
